import { render, staticRenderFns } from "./ActivityRule.vue?vue&type=template&id=51f630ca&scoped=true"
import script from "./ActivityRule.vue?vue&type=script&lang=js"
export * from "./ActivityRule.vue?vue&type=script&lang=js"
import style0 from "./ActivityRule.vue?vue&type=style&index=0&id=51f630ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f630ca",
  null
  
)

export default component.exports